module.exports = kolibriCoreAppGlobal.coreVue.components.BirthYearSelect;